
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetServerSideProps, NextPage } from 'next';
import styled from 'styled-components';
import { PageResponse, Page, ErrorMessage, PagesResponse } from '../types/api';
import fetcher from '../lib/fetcher';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import Richtext from '../components/Richtext';
import Text from '../components/Text';
import { space } from '../stylesheets';
const PageLayout = styled.div `
  max-width: 800px;
  margin: 0 auto;
  padding: ${space(['xxxl', 'm'])};

  h1 {
    margin-bottom: ${space('l')};
  }
`;
type GeneralPageProps = {
    page: Page;
};
const GeneralPage: NextPage<GeneralPageProps> = ({ page }) => {
    return (<>
      <SEO canonical={`/${page.meta.slug}`} title={page.meta.seo_title} description={page.meta.search_description}/>

      <Layout background="base">
        <PageLayout>
          <Text variant="headline-1" as="h1">
            {page.title}
          </Text>

          {page.content &&
            page.content.map(i => {
                if (i.type === 'single_richtext') {
                    return <Richtext key={i.id} content={i.value.text}/>;
                }
            })}
        </PageLayout>
      </Layout>
    </>);
};
const getServerSideProps: GetServerSideProps = async ({ res, locale, query }) => {
    /**
     * We first need to fetch every pages by slug query param
     * to get the id for the detail page
     */
    const { data: pages } = await fetcher<PagesResponse>(`/cms/pages?slug=${query.slug}-${locale}`);
    /**
     * If no items were found with given slug
     * return not found page
     */
    if (!pages.items || typeof pages.items[0] === 'undefined') {
        return {
            props: {},
            notFound: true
        };
    }
    /**
     * Parse the id from the first item
     * and fetch the detail page
     */
    const id = pages.items[0].id;
    const { data } = await fetcher<PageResponse>(`/cms/pages/${id}`);
    /**
     * If no entry was found with given id
     * return not found page
     */
    if ((data as any).message === ErrorMessage.PageNotFound) {
        return {
            props: {},
            notFound: true
        };
    }
    /**
     * Otherwise return data to page
     * with cache-control header
     */
    res.setHeader('Cache-Control', 's-maxage=30, stale-while-revalidate=300');
    return { props: { page: data } };
};
export default GeneralPage;

    async function __Next_Translate__getServerSideProps__18f80c52fc1__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[slug]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__18f80c52fc1__ as getServerSideProps }
  